import React, { useEffect } from "react";
import styles from "./TabPanel.module.scss";
import { combineClasses, updateParams } from "@/lib/utils";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";

const TabPanel = ({ tabNames = [], className = "" }) => {
  const [params, setParams] = useSearchParams();

  const handleTabChange = (index) => {
    updateParams({ tab: index }, setParams);
  };

  useEffect(() => {
    if (params.get("tab") === null) {
      setTimeout(() => {
        handleTabChange(0);
      });
    }
    //eslint-disable-next-line
  }, []);

  return (
    <div className={combineClasses(styles.tabPanel, className)}>
      {tabNames.map((tab, index) => {
        return tab ? (
          <span
            key={tab}
            className={combineClasses(
              styles.tabName,
              params.get("tab") === index?.toString() ? styles.active : ""
            )}
            onClick={() => handleTabChange(index)}
          >
            {tab}
          </span>
        ) : (
          ""
        );
      })}
    </div>
  );
};

TabPanel.propTypes = {
  tabNames: PropTypes.arrayOf(PropTypes.string), // expects an array of strings
  className: PropTypes.string, // CSS class for styling
};

export default TabPanel;
